<template lang="html">
  <div>
    <b-modal ref="modal-register" centered hide-footer no-close-on-backdrop no-close-on-esc modal-class="modal-user-access-layout" @hide="$parent.openedModal = null;" title="Registra tu cuenta">
      <div class="box-sm-title">
        <h6><span>Selecciona tu tipo de cuenta.</span></h6>
      </div>

      <div class="box-account-types">
        <div class="col-6 col-type col-user" v-bind:class="{ active: accType == 'user' }" @click="accType = 'user'">
          <div class="box">
            <div>
              <h5>Usuario</h5>
              <h6>Jobusco el mejor empleo</h6>
            </div>
          </div>
        </div>

        <div class="col-6 col-type col-employer" v-bind:class="{ active: accType == 'employer' }" @click="accType = 'employer'">
          <div class="box">
            <div>
              <h5>Empleador</h5>
              <h6>Jobusco el mejor talento</h6>
            </div>
          </div>
        </div>
      </div>

      <div class="box-form">
        <form role="form" class="form-horizontal" @submit.prevent="onSubmitReg($event.target)">
        <!-- <b-form @submit="onSubmitReg"> -->
          <div class="row">

            <div class="col-sm-12 col-input" v-if="accType == 'employer'">
              <b-form-group
                label="Nombre de la empresa*"
                label-for="i-1">
                <b-form-input
                  id="i-1"
                  size="sm"
                  v-model="formReg.nombre"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-input" v-if="accType == 'employer'">
              <b-form-group
                label="Nombre (s)*"
                label-for="i-1">
                <b-form-input
                  id="i-1"
                  size="sm"
                  v-model="formReg.nombre_responsable"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
             <div class="col-sm-6 col-input" v-else>
              <b-form-group
                label="Nombre (s)*"
                label-for="i-1">
                <b-form-input
                  id="i-1"
                  size="sm"
                  v-model="formReg.nombre"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>


            <div class="col-sm-6 col-input" v-if="accType == 'employer'">
              <b-form-group
                label="Apellido*"
                label-for="i-2">
                <b-form-input
                  id="i-2"
                  size="sm"
                  v-model="formReg.apellido_responsable"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-sm-6 col-input" v-else>
              <b-form-group
                label="Apellido*"
                label-for="i-2">
                <b-form-input
                  id="i-2"
                  size="sm"
                  v-model="formReg.apellido"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-input">
              <b-form-group
                label="Teléfono*"
                label-for="i-7">
                <b-form-input
                  id="i-7"
                  size="sm"
                  v-model="formReg.telefono"
                  required
                  minlength="10"
                  maxlength="10"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-input">
              <b-form-group
                label="Correo electrónico*"
                label-for="i-4">
                <b-form-input
                  id="i-4"
                  size="sm"
                  v-model="formReg.email"
                  type="email"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

             <div class="col-sm-6 col-input" v-if="accType != 'employer'">
               <b-form-group
                label="Estado"
                label-for="i-6">
                <v-select v-model="formReg.estado_id" :options="statesOpcs" label="name" index="id" required/>
              </b-form-group>
            </div>
             <div class="col-sm-6 col-input" v-if="accType != 'employer'">
               <b-form-group
                label="Cuidad"
                label-for="i-6">
                <v-select v-model="formReg.ciudad_id" :options="townsOpcs" label="name" index="id" required/>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-input box-profile-imag" v-if="accType != 'employer'">
                <label class="d-block">Foto de perfil*</label>
                <input type="file" required accept=".jpg,.jpeg,.png" name="image" required>
            </div>

            <div class="col-sm-6 col-input">
              <b-form-group
                label="Contraseña*"
                label-for="i-5">
                <div class="eye-box">
                  <b-form-input
                    id="i-5"
                    size="sm"
                    v-model="formReg.password"
                    type="password"
                    required
                  ></b-form-input>
                  <i class="fas ic-eye" v-bind:class="{ 'fa-eye' : showpass, 'fa-eye-slash' : !showpass }"  @click="showpass = !showpass"></i>
                </div>
              </b-form-group>
            </div>

            <div class="col-sm-6 col-input">
              <b-form-group
                label="Repetir contraseña*"
                label-for="i-6">
                <div class="eye-box">
                  <b-form-input
                    id="i-6"
                    size="sm"
                    v-model="formReg.reppassword"
                    type="password"
                    required
                  ></b-form-input>
                  <i class="fas ic-eye" v-bind:class="{ 'fa-eye' : showpasstwo, 'fa-eye-slash' : !showpasstwo }"  @click="showpasstwo = !showpasstwo"></i>
                </div>
              </b-form-group>
            </div>



            <div class="col-sm-6 col-input" v-if="accType == 'employer'">
               <b-form-group
                label="Areas"
                label-for="i-6">
                <v-select v-model="formReg.categorias" :options="categoriesOpcs" label="nombre" index="id" multiple/>
              </b-form-group>
            </div>



            <!--div class="col-12 mt-3 col-input" v-if="accType == 'employer'">
              <b-form-group
                label="Nombre de la empresa*"
                label-for="i-9">
                <b-form-input
                  id="i-9"
                  size="sm"
                  v-model="formReg.empresa"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div-->

            <div class="col-12 mt-2 col-input">
              <b-form-checkbox
                v-model="formReg.checkbox"
                name="checkbox-1"
                value="accepted"
                :unchecked-value="null">
                Al hacer clic en la casilla de verificación, acepta nuestros <a @click="openModal(1)" href="#">Términos y condiciones</a> y <a href="#" @click="openModal(2)">Política de privacidad</a>
              </b-form-checkbox>
            </div>

            <div class="col-12 col-bottom">
              <div class="row align-items-center">
                <div class="col-sm-6 col-btn">
                  <b-button type="submit" class="btn-cur-1 lg" v-if="loadinglogin == false" id="btnsave">Registrar</b-button>
                  <img src="/public/images/shared/loading.gif" style="width: 100px;" v-else>
                </div>

                <div class="col-sm-6 col-links">
                  <a @click="toggleModal()">¿Ya tienes cuenta? Ingresa</a>
                </div>
              </div>
            </div>

          </div>
        <!-- </b-form> -->
        </form>
      </div>

      <!-- <div class="mt-2 box-sm-title">
        <h6><span>o ingresa con</span></h6>
      </div> -->
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{
      accType: 'user',

      formReg: {
        nombre: null,
        telefono:null,
        estado_id:null,
        ciudad_id:null,
        categorias:[],
        imagenes_id:null
      },
      formLogin: {
        email: null,
        password: null,
        type:null
      },
      categoriesOpcs:[],
      loadinglogin:false,
      showpass:false,
      showpasstwo:false,
      statesOpcs:[],
      townsOpcs:[],
    }
  },

  methods: {
    toggleModal(){
      this.$refs['modal-register'].hide();
      setTimeout( ()=>{ this.$parent.openedModal = 'login'; }, 200);
    },

    onSubmitReg(form) {
        this.loadinglogin = true;
        $( "#btnsave" ).prop( "disabled", true );

        if (this.accType == 'user') {

            var hayImagen = true;

          if(jQuery('input[type=file]')[0].files[0] == undefined){
            hayImagen = false;
          }
          if(hayImagen)
          {
              var formData = new FormData();
              formData.append("image", jQuery('input[type=file]')[0].files[0]);

              var imagenes_id = null;
              var url = "";
              var error = false;

              jQuery.ajax({

                 url:"https://jobusco.com/api/V1.0.0/api/sync/save_img",
                  type: "POST",
                  headers: {

                  },
                processData: false,
                  contentType: false,
                  data: formData,
                  async:false,
              })
              .done(function(data, textStatus, jqXHR) {
                  console.log("HTTP Request Succeeded: " + jqXHR.status);
                  console.log(data);
                  imagenes_id = data.data.id;
                  //url = data.data.url;
              })
              .fail(function(jqXHR, textStatus, errorThrown) {
                  console.log("HTTP Request Failed");
                  //alert("Hubo un problema al guardar la imagen.");
                  error = true;
              })

              if(error)
              {
                this.$parent.showMessage("Hubo un problema al subir la imagen.","warning");
                return false;
              }

              this.formReg.imagenes_id = imagenes_id;

          }

          var data=tools.params(form,this.formReg);


          axios.post(tools.url("/storeUsersFront"),data).then((response)=>{
              $( "#btnsave" ).prop( "disabled", false  );
              this.$refs['modal-register'].hide();
              this.onLogin();
              alert('Registro completado exitosamente');


          }).catch((error)=>{
              $( "#btnsave" ).prop( "disabled", false  );
              this.loadinglogin = false;
              if(error.response.data.msg == 'correoduplicado'){
                  alert('Ya existe una cuenta con el correo ingresado!');
              }
              else{
                  alert('Ocurrio un error al guardar!');
              }
          });
      }
      else{

          var data=tools.params(form,this.formReg);
          var categorias_array = JSON.stringify(this.formReg.categorias);
          data.append('categorias',categorias_array);

          axios.post(tools.url("/storeCompaniesFront"),data).then((response)=>{

              $( "#btnsave" ).prop( "disabled", false  );
              this.$refs['modal-register'].hide();
              this.onLogin();
              alert('Registro completado exitosamente');
          }).catch((error)=>{
             $( "#btnsave" ).prop( "disabled", false  );
              this.loadinglogin = false;
              if(error.response.data.msg == 'correoduplicado'){
                  alert('Ya existe una cuenta con el correo ingresado!');
              }
              else{
                  alert('Ocurrio un error al guardar!');
              }


          });
      }


    },
    getCategories(){

        axios.get(tools.url("/categoriesFront"))
        .then((response)=>{
            this.categoriesOpcs = response.data;
          }).catch((error)=>{
            this.$parent.handleErrors(error);
          });
    },
    onLogin() {

        this.formLogin.type = this.accType;
        this.formLogin.email = this.formReg.email;
        this.formLogin.password = this.formReg.password;


        axios.get(tools.url('/sanctum/csrf-cookie')).then(() => {
          axios.post(tools.url("/loginFront"),this.formLogin).then((response)=>{
              this.$root.user = response.data;
              if (this.$root.user.roles[0].name == 'empresa') {
                  this.formReg = {};
                  this.$root.logged=true;
                  this.$root.type_logged = 'empresa';

                  this.$router.push('/cuenta-empresa');
              }
              else if(this.$root.user.roles[0].name == 'cliente'){
                   this.$root.user = response.data;
                  this.$root.logged=true;
                  this.$root.type_logged = 'usuario';

                  this.$router.push('/cuenta-usuario');

              }


              //location.reload();

          }).catch((error)=>{
              this.form_errors = true;

          });
        });

        //console.log('Login...');
    },
    openModal(type){
        if (type == 1) {
            this.$parent.openedModal = 'terminos';

        }
        else{
            this.$parent.openedModal = 'aviso';
        }
    },
    getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
  },

  watch: {
    '$parent.openedModal': function (val, oldVal) {
      if(val == 'register'){
        this.$refs['modal-register'].show();
      }
    },
    'showpass':function (val) {
          if (val == true) {
              $("#i-5").prop('type','text');
          }
          else if (val == false) {
            $("#i-5").prop('type','password');
          }
      },
      'showpasstwo':function (val) {
          if (val == true) {
              $("#i-6").prop('type','text');
          }
          else if (val == false) {
            $("#i-6").prop('type','password');
          }
      },
      'formReg.estado_id':function(val){
          this.getTownsOpcs(val);
      },
  },

  mounted(){
    this.getStatesOpcs();
    this.getCategories();
    // this.$refs['modal-register'].show();
  }
}
</script>
